import * as React from 'react';
/**
 * Context which holds the route prop for a screen.
 */
const NavigationContainerRefContext = /*#__PURE__*/React.createContext(undefined);
export default NavigationContainerRefContext;
//# sourceMappingURL=NavigationContainerRefContext.js.map